import axios from 'axios'

export const kabkota = {
    methods: {
        // store data wilayah kabkota
        async store () {
            try {
                this.form.nama = this.form.nama.toUpperCase()
                if (this.helper.provinsi_id == undefined && this.helper.kode == undefined) {
                    this.form.kode = ''
                } else {
                    this.form.kode = this.helper.provinsi_id + '.' + this.helper.kode
                }
                await this.form.post('/api/data-induk/wilayah-indonesia/kabkota/')
                this.helper = {
                    errors: ''
                }
                this.reset(this.helper)
                this.$swal({
                    icon: "success",
                    title: "Data berhasil ditambah",
                    type: "success",
                    confirmButtonClass: "btn btn-info",
                    showConfirmButton: true,
                    showCloseButton: true,
                    confirmButtonText: "OKE",
                    allowOutsideClick: false,
                    timer: 5000
                });
                this.reload()
            } catch (error) {
                if (error.response.status == 422) {
                    this.helper.errors = error.response.data
                } else {
                    console.log(error)
                }
            }
        },
        // update data wilayah kabkota
        async update (id) {
            try {
                this.form.nama = this.form.nama.toUpperCase()
                this.form.kode = this.helper.provinsi_id + '.' + this.helper.kode
                await this.form.put('/api/data-induk/wilayah-indonesia/kabkota/' + id)
                this.detail(id)
                this.$swal({
                    icon: "success",
                    title: "Data berhasil dirubah",
                    type: "success",
                    confirmButtonClass: "btn btn-info",
                    showConfirmButton: true,
                    showCloseButton: true,
                    confirmButtonText: "OKE",
                    allowOutsideClick: false,
                    timer: 5000
                });
                this.reload()
            } catch (error) {
                if (error.response.status == 422) {
                    this.helper.errors = error.response.data
                } else {
                    console.log(error)
                }
            }
        },
        // detail kabkota
        async detail (id) {
            try {
                let response = await axios.get('/api/data-induk/wilayah-indonesia/kabkota/' + id)
                this.form.fill(response.data.data)
                let kodeArr = this.form.kode.split('.')
                this.helper.provinsi_id = kodeArr[0]
                this.helper.kode = kodeArr[1]
            } catch (error) {
                if (error.response.status == 401) {
                    // reset mixin (cek folder helper)
                    this.tokenClear()
                }
            }
        }
    }
}

export default kabkota